export default function Loader() {
  return <p>Loading...</p>;
}